module.exports = __webpack_public_path__ + "img/qa1.fcdeba64.jpg";